export const getCallList = (call, isMobile) => {
  const callObject = {
    filer: { color: '#FFFCD1', paddingTop: isMobile ? '15px' : '15px' },
    stocks: {
      name: 'Stocks',
      color: 'rgba(225,240,216,255)',
      paddingTop: '0px',
    },
    calls: {
      name: 'Calls',
      color: 'rgba(225,240,216,255)',
      paddingTop: '0px',
    },
    puts: { name: 'Puts', color: '#fee2e2', paddingTop: '0px' },
  };
  const callKeys = Object.keys(call);
  callKeys.forEach((key) => {
    switch (true) {
      case key === 'filer':
        callObject.filer = { ...callObject.filer, name: call[key] };
        break;
      case key === 'shares':
        callObject.stocks = {
          ...callObject.stocks,
          cel1: call[key].toLocaleString(),
        };
        break;
      case key === 'shares_chg':
        callObject.stocks = {
          ...callObject.stocks,
          cel2: call[key].toLocaleString(),
        };
        break;
      case key === 'quarter_date':
        callObject.stocks = { ...callObject.stocks, cel3: call[key] };
        callObject.calls = { ...callObject.calls, cel3: call[key] };
        callObject.puts = call.puts > 0 && {
          ...callObject.puts,
          cel3: call[key],
        };
        break;
      case key === 'calls':
        callObject.calls = {
          ...callObject.calls,
          cel1: call[key].toLocaleString(),
        };
        break;
      case key === 'calls_chg':
        callObject.calls = {
          ...callObject.calls,
          cel2: call[key].toLocaleString(),
        };
        break;
      case key === 'puts':
        callObject.puts = {
          ...callObject.puts,
          cel1: call[key].toLocaleString(),
        };
        break;
      case key === 'puts_chg':
        callObject.puts = {
          ...callObject.puts,
          cel2: call[key].toLocaleString(),
        };
        break;

      default:
        // eslint-disable-next-line no-unused-expressions
        'No key Found';
        break;
    }
  });

  let dataToReturn;
  dataToReturn =
    call.puts > 0
      ? [
          { ...callObject.filer },
          { ...callObject.stocks },
          { ...callObject.calls },
          { ...callObject.puts },
        ]
      : [
          { ...callObject.filer },
          { ...callObject.stocks },
          { ...callObject.calls },
        ];
  return dataToReturn;
};

export const getPuttList = (puts, isMobile) => {
  const callObject = {
    filer: { color: '#FFFCD1', paddingTop: isMobile ? '15px' : '15px' },
    stocks: {
      name: 'Stocks',
      color: 'rgba(225,240,216,255)',
      paddingTop: '0px',
    },
    calls: {
      name: 'Calls',
      color: 'rgba(225,240,216,255)',
      paddingTop: '0px',
    },
    puts: { name: 'Puts', color: '#fee2e2', paddingTop: '0px' },
  };
  const callKeys = Object.keys(puts);

  callKeys.forEach((key) => {
    switch (true) {
      case key === 'filer':
        callObject.filer = { ...callObject.filer, name: puts[key] };
        break;
      case key === 'shares':
        callObject.stocks = {
          ...callObject.stocks,
          cel1: puts[key].toLocaleString(),
        };
        break;
      case key === 'shares_chg':
        callObject.stocks = {
          ...callObject.stocks,
          cel2: puts[key].toLocaleString(),
        };
        break;
      case key === 'quarter_date':
        callObject.stocks = { ...callObject.stocks, cel3: puts[key] };
        callObject.calls = { ...callObject.calls, cel3: puts[key] };
        callObject.puts = { ...callObject.puts, cel3: puts[key] };
        break;
      case key === 'calls':
        callObject.calls = {
          ...callObject.calls,
          cel1: puts[key].toLocaleString(),
        };
        break;
      case key === 'calls_chg':
        callObject.calls = {
          ...callObject.calls,
          cel2: puts[key].toLocaleString(),
        };
        break;
      case key === 'puts':
        callObject.puts = {
          ...callObject.puts,
          cel1: puts[key].toLocaleString(),
        };
        break;
      case key === 'puts_chg':
        callObject.puts = {
          ...callObject.puts,
          cel2: puts[key].toLocaleString(),
        };
        break;

      default:
        // eslint-disable-next-line no-unused-expressions
        'No key Found';
        break;
    }
  });
  let dataToReturn;
  dataToReturn =
    puts.calls > 0
      ? [
          { ...callObject.filer },
          { ...callObject.stocks },
          { ...callObject.calls },
          { ...callObject.puts },
        ]
      : [
          { ...callObject.filer },
          { ...callObject.stocks },
          { ...callObject.puts },
        ];
  return dataToReturn;
};



// WEBPACK FOOTER //
// ./src/components/Modals/Holders Modal/components/constant.js